import { API } from "./config";
import { convertKeysToCamelCase, filterObjectProperties, objectToQueryString } from "../utils";
import { axiosClientOrder, handleRequest } from "./axiosClient";


export const getOrders = async (params) => {
    const queryString = objectToQueryString(params);
    const url = `${API.orders.seller}?${queryString}`;
    const response = await handleRequest(axiosClientOrder.get(url));
    const newResponse = {
        items: convertKeysToCamelCase(response?.data?.data?.items),
        success: response?.data?.message === 'success',
        code: response?.data?.code,
        total: response?.data?.data?.total,
        size: response?.data?.data?.size,
        page: response?.data?.data?.page,
    }
    return { ...newResponse };
};
export const getOrderDetail = async (orderId) => {
    const url = `${API.orders.sellerDetail.replace("{id}", orderId)}`;
    const response = await handleRequest(axiosClientOrder.get(url));
    const newResponse = {
        order: convertKeysToCamelCase(response?.data?.data),
        success: response?.data?.message === 'success',
        code: response?.data?.code,
    }
    return { ...newResponse };
};
export const getOrderCountStatusAllTime = async () => {
    const url = `${API.orders.sellerCountStatusAllTime}`;
    const response = await handleRequest(axiosClientOrder.get(url));
    const newResponse = {
        countStatus: convertKeysToCamelCase(response?.data?.data),
        success: response?.data?.message === 'success',
        code: response?.data?.code,
    }
    return { ...newResponse };
};
export const getOrderCountStatusMonth = async (params) => {
    const queryString = objectToQueryString(params);
    const url = `${API.orders.sellerCountStatusMonth}?${queryString}`;
    const response = await handleRequest(axiosClientOrder.get(url));
    const newResponse = {
        countStatus: convertKeysToCamelCase(response?.data?.data),
        success: response?.data?.message === 'success',
        code: response?.data?.code,
    }
    return { ...newResponse };
};

export const setCancelOrder = ({ orderId, reason }) => {
    const url = `${API.orders.sellerCancel}`;
    const params = filterObjectProperties({ orderId, reason })
    return handleRequest(axiosClientOrder.post(url, params));
}
export const setRefundOrder = ({ orderId, reason }) => {
    const url = `${API.orders.sellerRefund}`;
    const params = filterObjectProperties({ orderId, reason })
    return handleRequest(axiosClientOrder.post(url, params));
}

export const setConfirmOrder = (params) => {
    const url = `${API.orders.sellerConfirmOrder}`;
    const newParams = filterObjectProperties(params)
    return handleRequest(axiosClientOrder.post(url, newParams));
}
export const setConfirmOrderSuccess = ({ orderId }) => {
    const url = `${API.orders.sellerConfirmOrderSuccess.replace("{id}", orderId)}`;
    const newParams = filterObjectProperties({ status: "shipping_done" })
    return handleRequest(axiosClientOrder.put(url, newParams));
}

export const getSellerOrderNotes = async (orderId, params) => {
    const queryString = objectToQueryString(params);
    const url = `${API.orders.sellerOrderNotes.replace("{id}", orderId)}?${queryString}`;
    const response = await handleRequest(axiosClientOrder.get(url));
    const newResponse = {
        items: convertKeysToCamelCase(response?.data?.data?.items),
        success: response?.data?.message === 'success',
        code: response?.data?.code,
        total: response?.data?.data?.total,
        size: response?.data?.data?.size,
        page: response?.data?.data?.page,
    }
    return { ...newResponse };
};
export const createSellerOrderNote = (orderId, payload) => {
    const url = `${API.orders.sellerOrderNotes.replace("{id}", orderId)}`;
    return handleRequest(axiosClientOrder.post(url, payload));
};
export const getSellerOrderNoteDetail = (orderId, noteId) => {
    const url = `${API.orders.sellerOrderNoteDetail.replace("{id}", orderId).replace("{noteId}", noteId)}`;
    return handleRequest(axiosClientOrder.get(url));
};
export const updateSellerOrderNote = (orderId, noteId, payload) => {
    const url = `${API.orders.sellerOrderNoteDetail.replace("{id}", orderId).replace("{noteId}", noteId)}`;
    return handleRequest(axiosClientOrder.put(url, payload));
};
export const deleteSellerOrderNote = (orderId, noteId) => {
    const url = `${API.orders.sellerOrderNoteDetail.replace("{id}", orderId).replace("{noteId}", noteId)}`;
    return handleRequest(axiosClientOrder.delete(url));
};
